module.exports = __webpack_public_path__ + "src/assets/images/landing/Intro/green-cat.png";